import React from "react";
import styled, { css } from "styled-components";

import { ButtonLink } from "src/library/components/Link";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import { Text } from "src/library/components/Text";
import { ITerminology } from "src/library/utils";
import {
  ICustomer,
  useCustomerApi
} from "src/core/customers/api/customers.api";

interface DefaultCustomerProps{
  customerId?: number
  terminology: ITerminology
}

/**
 * This is a component which presents the default Customer with a "view" button.
 * it takes in a Customer id so could technically show any Customer.
 */
const DefaultCustomer: React.ReactFCWithChildren<DefaultCustomerProps> = props => {
  const { customerId, terminology } = props;
  const [ defaultCustomerRes, getDefaultCustomer ] = useCustomerApi("GET_CUSTOMER");
  const [ defaultCustomer, setDefaultCustomer ] = React.useState<ICustomer | null>(null);

  React.useEffect(() => {
    if (customerId) {
      getDefaultCustomer(customerId);
    }
  }, [ customerId, getDefaultCustomer ]);

  React.useEffect(() => {
    if (defaultCustomerRes.data && defaultCustomerRes.complete) {
      setDefaultCustomer(defaultCustomerRes.data);
    }
  }, [ defaultCustomerRes ]);

  return (
    <DefaultCustomerWrapper>
      {defaultCustomer ? (
        <div className="default-Customer">
          <div className="title-Customer">
            <div className="title">
              <Text
                as="h4"
              >
                {`Default ${terminology.customer.singular.text}`}
                :
              </Text>
            </div>

            <div className="Customer-spinner">
              <div className="Customer">
                <Text as="h3">
                  {`${defaultCustomer.accountNumber} - ${defaultCustomer.name} `}
                </Text>

                <ButtonLink
                  $buttonType="primary"
                  className="orders-button"
                  to={`/admin/customers/${defaultCustomer.id}/drops`}
                >
                  View
                </ButtonLink>
              </div>

              {defaultCustomerRes.pending && defaultCustomerRes ? (
                <div className="spinner-container">
                  <LoadingSpinner
                    type="flat"
                    position="inline"
                  />
                </div>
              ) : <></>}
            </div>
          </div>
        </div>
      ) : (
        <div className="spinner-container">
          <LoadingSpinner
            type="flat"
            position="inline"
          />
        </div>
      )}
    </DefaultCustomerWrapper>
  );
};

const DefaultCustomerWrapper = styled.div`
  ${({ theme }) => css`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${theme.spacing.margins.md};

  .default-Customer{
    display: flex;
    flex-direction: column
  }
  
  .title-Customer{
    display: flex;
    flex-direction: column
  }

  .Customer-spinner{
    display: flex;
    flex-direction: row;
    height:min-content;
  }

  .Customer{
    border-radius: 5px;
    background-color:${theme.colors.lightestGrey};
    padding: ${theme.spacing.padding.md};
    display: flex;
    flex-direction: row;
    align-items:center;
  }

  .title{
    margin-top: ${theme.spacing.margins.sm};
    justify-self: center;
    margin-bottom: ${theme.spacing.margins.sm};
  }
  
  .default-Customer h3 {
    margin-bottom: 0px;
    padding-right: ${theme.spacing.padding.md};
  }
  
  .default-Customer h4{
    margin-bottom:0px;
  }
  
  .spinner-container {
    display: flex;
    margin: ${theme.spacing.padding.sm};
    align-items: center;
`}`;

export default DefaultCustomer;
